import { BettingInformation } from '../Model/BettingInformation'
import AllwaysCheckBoxValidatorProcessor from './AllwaysCheckBoxValidatorProcessor'
import { ICheckBoxValidatorProcessor } from './ICheckBoxValidatorProcessor'
import { ICheckBoxValidatorProcessorPipeline } from './ICheckBoxValidatorProcessorPipeline'
import RegularCheckBoxValidatorProcessor from './RegularCheckBoxValidatorProcessor'
import RovingBankerCheckBoxValidatorProcessor from './RovingBankerCheckBoxValidatorProcessor'

export default class CheckBoxValidatorProcessorPipeline
  implements ICheckBoxValidatorProcessorPipeline
{
  constructor() {
    this.head = new RegularCheckBoxValidatorProcessor(
      new RovingBankerCheckBoxValidatorProcessor(
        new AllwaysCheckBoxValidatorProcessor(null as unknown as ICheckBoxValidatorProcessor)
      )
    )
  }

  validate(count: number, bettingContext: BettingInformation): boolean {
    return this.head.validate(count, bettingContext)
  }

  private head: ICheckBoxValidatorProcessor
}
